// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function Label$BaseLabel(props) {
  var __size = props.size;
  var size = __size !== undefined ? __size : "md";
  var sizeClass = size === "lg" ? "px-3 py-1" : "px-2.5 py-0.5";
  return JsxRuntime.jsx("span", {
              children: props.children,
              className: TailwindMerge.twMerge([
                    "rounded-full font-medium whitespace-nowrap text-[13px]",
                    sizeClass,
                    props.className
                  ])
            });
}

var BaseLabel = {
  make: Label$BaseLabel
};

function Label$Positive(props) {
  return JsxRuntime.jsx(Label$BaseLabel, {
              size: props.size,
              className: "bg-green-50 text-green-700",
              children: props.text
            });
}

var Positive = {
  make: Label$Positive
};

function Label$Neutral(props) {
  var __variant = props.variant;
  var variant = __variant !== undefined ? __variant : "default";
  var bgColor = variant === "default" ? "bg-gray-200" : "bg-gray-50";
  return JsxRuntime.jsx(Label$BaseLabel, {
              size: props.size,
              className: bgColor + " text-gray-700",
              children: props.text
            });
}

var Neutral = {
  make: Label$Neutral
};

function Label$Info(props) {
  return JsxRuntime.jsx(Label$BaseLabel, {
              size: props.size,
              className: "bg-blue-100 text-blue-900",
              children: props.text
            });
}

var Info = {
  make: Label$Info
};

exports.BaseLabel = BaseLabel;
exports.Positive = Positive;
exports.Neutral = Neutral;
exports.Info = Info;
/* tailwind-merge Not a pure module */
